import React, { useState } from "react";
import { Card, CardImg, CardBody, CardText, Badge, Col, Row } from "reactstrap";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png";
import developerdImg from "assets/images/developer_logo.png";
import compoundLogo from "assets/images/compound.png";
import itemTypes from "Enums/itemTypes";
import { useDrag } from "react-dnd";
import { add } from "lodash";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import AuthCard from "components/Website/Cards/AuthCard";
import { useSelector, useDispatch } from "react-redux";
import { authenticate, addInterest } from "store/Auth/actions";
import { useTranslation } from "react-i18next";

const CardItem = ({ compound, AddToSelectedCompounds, history, type }) => {
	// const [modal, setModal] = useState(false)
	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth.currency);
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const checkAuth = () => {
		if (type === "compare") {
			AddToSelectedCompounds(compound);
		} else if (AuthData.token && AuthData.userType === "user") {
			history.push(`/compound-details/${compound.id}`);
		} else {
			dispatch(
				authenticate({ navigateTo: `/compound-details/${compound.id}` })
			);
			history.push(`/login`, {
				navigateTo: `/compound-details/${compound.id}`,
			});
		}
	};
	return (
		<div className="position-relative">
			<Card className="comCard mx-2" onClick={checkAuth}>
				{compound?.images?.length > 0 ? (
					compound?.images?.map((img, index) => {
						if (index === 0) {
							return <CardImg key={index} src={img.path}></CardImg>;
						}
					})
				) : (
					<CardImg src={compoundImg}></CardImg>
				)}
				<div className="comp-details">
					<p className="text-white fw-bold">
						{compound?.name[`${AuthData.lang}`]
							? compound?.name[`${AuthData.lang}`]
							: compound?.name.en}
					</p>
				</div>
				{/* <CardBody className="bodyComapre">
					{compound?.developer?.media?.id ? (
						<img src={compound.developer.media.path} className="imgAbsolute" />
					) : (
						<img src={developerdImg} className="imgAbsolute" />
					)}
					<Row>
						<Col md={12}>
							<CardText tag="h4" className="font-size-14 fw-bold">
								{compound?.name[`${AuthData.lang}`]
									? compound?.name[`${AuthData.lang}`]
									: compound?.name.en}
							</CardText>
						</Col>
					</Row>
					<CardText tag="h4" className="font-size-14 pt-3">
						{compound?.installment
							? t("up to installment", { num: compound?.installment })
							: t("only cash")}
					</CardText>
					<Row className="pt-2">
						<Col md={6}>
							<CardText tag="p" className="font-size-13 text-muted mb-1">
								{t("starting from")}
							</CardText>
							<CardText tag="h4" className="font-size-14">
								{toCurrency(compound?.starting_from)} {currency?.currency_code}
							</CardText>
						</Col>
						<Col md={6}>
							<CardText tag="p" className="font-size-13 text-muted mb-1">
								{t("to")}
							</CardText>
							<CardText tag="h4" className="font-size-14">
								{toCurrency(compound?.end_to)} {currency?.currency_code}
							</CardText>
						</Col>
					</Row>
				</CardBody> */}
			</Card>
			<button
				onClick={() => {
					AddToSelectedCompounds(compound);
				}}
				className="btn mx-auto d-block position-absolute comparison-button add-comp">
				<i className="fa fa-plus-circle "></i>
			</button>
			{/* <AuthCard modal={modal} setModal={setModal} history={history} /> */}
		</div>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};

export default CardItem;
